import { MapPin, Phone, Clock, Star } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { WA_LINK, PHONE_TEL, WA_NUMBER_DISPLAY, ADDRESS, MAPS_LINK, MAPS_EMBED } from "../site";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const Visit = () => (
  <section id="visit" data-testid="visit-section" className="bg-ink-soft/40 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-28 md:py-40">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-16">
        <div className="md:col-span-7">
          <Reveal>
            <Overline>Visit Us</Overline>
            <h2 className="mt-6 font-serif font-light tracking-tight leading-tight text-4xl sm:text-5xl md:text-6xl text-stone-100">
              Tonight is a<br /><span className="italic text-gold-300">good time</span>
            </h2>
            <p className="mt-8 max-w-md text-base md:text-lg font-light leading-relaxed text-stone-300">
              We never close. Send one message and your room is prepared — oils warmed, stones heated, lights low.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-12 flex flex-col sm:flex-row gap-4">
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="visit-book-button"
                className="inline-flex items-center justify-center gap-3 rounded-full bg-wa px-8 py-4 text-base font-semibold text-ink transition-transform duration-300 hover:scale-[1.03] shadow-[0_0_30px_rgba(37,211,102,0.35)]"
              >
                <WhatsAppIcon className="w-5 h-5" />
                Book via WhatsApp
              </a>
              <a
                href={PHONE_TEL}
                data-testid="visit-call-button"
                className="inline-flex items-center justify-center gap-3 rounded-full border border-white/20 px-8 py-4 text-base font-medium text-stone-100 transition-colors duration-300 hover:border-gold-400 hover:text-gold-300"
              >
                <Phone className="w-5 h-5" />
                Call {WA_NUMBER_DISPLAY}
              </a>
            </div>
          </Reveal>
        </div>
        <div className="md:col-span-5">
          <Reveal delay={0.2}>
            <dl className="space-y-8 border-l border-white/10 pl-8">
              <div data-testid="visit-address">
                <dt className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-gold-400 font-semibold"><MapPin className="w-4 h-4" /> Address</dt>
                <dd className="mt-3 text-base md:text-lg font-light text-stone-200 leading-relaxed">{ADDRESS}</dd>
                <a href={MAPS_LINK} target="_blank" rel="noopener noreferrer" data-testid="visit-directions-link" className="mt-2 inline-block text-sm text-gold-400 underline-offset-4 hover:underline">
                  Get directions
                </a>
              </div>
              <div data-testid="visit-hours">
                <dt className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-gold-400 font-semibold"><Clock className="w-4 h-4" /> Hours</dt>
                <dd className="mt-3 text-base md:text-lg font-light text-stone-200">Open 24 hours, every day</dd>
              </div>
              <div data-testid="visit-rating">
                <dt className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-gold-400 font-semibold"><Star className="w-4 h-4" /> Google Rating</dt>
                <dd className="mt-3 text-base md:text-lg font-light text-stone-200">4.0 from 25 reviews</dd>
              </div>
            </dl>
          </Reveal>
        </div>
      </div>
      <Reveal delay={0.1}>
        <div data-testid="visit-map-embed" className="mt-16 md:mt-24 overflow-hidden rounded-2xl border border-white/10 shadow-[0_20px_60px_rgba(0,0,0,0.5)]">
          <iframe
            title="Relax Massage Spa — Concorde Palace Hotel, Bur Dubai"
            src={MAPS_EMBED}
            className="w-full h-[320px] md:h-[420px] block grayscale-[35%] contrast-[1.05] opacity-90 transition-opacity duration-500 hover:opacity-100"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
